export default {
  line_items: [
    {
      lead_times: [1, 2, 4, 6],
      pricing: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [4, 8, 16, 32],
      product_key: null,
      quote_config_key: null,
    },
  ],
};
